var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.774,
    height: 58.028,
    viewBox: "0 0 50.774 58.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37517",
    "data-name": "Group 37517",
    transform: "translate(-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35282",
    "data-name": "Path 35282",
    d: "M99.627,0A3.637,3.637,0,0,0,96,3.627V54.4a3.637,3.637,0,0,0,3.627,3.627h36.267a3.637,3.637,0,0,0,3.627-3.627V14.507L125.014,0Z",
    transform: "translate(-56.747)",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35283",
    "data-name": "Path 35283",
    d: "M355.627,14.507h10.88L352,0V10.88A3.637,3.637,0,0,0,355.627,14.507Z",
    transform: "translate(-283.733)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35284",
    "data-name": "Path 35284",
    d: "M394.88,138.88,384,128h10.88Z",
    transform: "translate(-312.106 -113.493)",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35285",
    "data-name": "Path 35285",
    d: "M75.521,259.947a1.819,1.819,0,0,1-1.813,1.813H33.813A1.819,1.819,0,0,1,32,259.947V241.813A1.819,1.819,0,0,1,33.813,240H73.708a1.819,1.819,0,0,1,1.813,1.813Z",
    transform: "translate(0 -212.799)",
    fill: "#f15642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37516",
    "data-name": "Group 37516",
    transform: "translate(39.904 33.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35286",
    "data-name": "Path 35286",
    d: "M101.744,295.321a1,1,0,0,1,.985-1h3.349a3.625,3.625,0,0,1,0,7.25h-2.421v1.915a.91.91,0,0,1-.928,1,.977.977,0,0,1-.985-1Zm1.913.825v3.612h2.421a1.807,1.807,0,0,0,0-3.612Z",
    transform: "translate(-101.744 -294.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35287",
    "data-name": "Path 35287",
    d: "M188.825,305.505a.907.907,0,0,1-1-.9v-8.236a.986.986,0,0,1,1-.9h3.32c6.626,0,6.481,10.033.131,10.033Zm.914-8.264v6.5h2.406c3.915,0,4.089-6.5,0-6.5Z",
    transform: "translate(-178.068 -295.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35288",
    "data-name": "Path 35288",
    d: "M289.033,297.344v2.3h3.7a1.121,1.121,0,0,1,1.044,1.028,1.008,1.008,0,0,1-1.044.87h-3.7v3.045a.859.859,0,0,1-.869.9.921.921,0,0,1-1.028-.9v-8.236a.916.916,0,0,1,1.028-.9h5.09a.9.9,0,0,1,1.015.9,1,1,0,0,1-1.015.986h-4.222Z",
    transform: "translate(-266.125 -295.327)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35289",
    "data-name": "Path 35289",
    d: "M130.454,417.813H96v1.813h34.454a1.819,1.819,0,0,0,1.813-1.813V416A1.819,1.819,0,0,1,130.454,417.813Z",
    transform: "translate(-56.747 -368.852)",
    fill: "#cad1d8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.c7243e33dfdc397e78163c07ec2c091b.svg";
export { ForwardRef as ReactComponent };